import { PUT_INFO_TALENT_ERROR, PUT_INFO_TALENT_START, PUT_INFO_TALENT_SUCCESS } from '../../types';

export default function put_info_talent(state, action) {
  switch (action.type) {
    case PUT_INFO_TALENT_START:
      return { ...state };
    case PUT_INFO_TALENT_SUCCESS:
      return {
        ...state,
        data: action.results,
        error: null,
      };
    case PUT_INFO_TALENT_ERROR:
      return {
        ...state,
        data: null,
        error: action.error
      };
    default:
      return { ...state };
  }
}